module.exports = __webpack_public_path__ + "assets/img/title-16fe1712.png";